import React from "react";
import { injectIntl } from "react-intl";
import { useSelector } from "react-redux";
import StatisticsCard from "../statisticsCard/StatisticsCard";
import AddIcon from "@material-ui/icons/Add";
// import CachedIcon from '@material-ui/icons/Cached';
import CheckIcon from '@material-ui/icons/Check';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import BlockIcon from '@material-ui/icons/Block';
import { Link } from "react-router-dom";
import "./appointmentsStatisticsWrapper.scss"

const AppointmentsStatisticsWrapper = ({ intl: { messages }, statistics }) => {
  const user = useSelector((state) => state.auth?.user?.data);

  if (!user) return null

  return (
    <div className={`d-md-flex justify-content-between px-0 apps`}>
      <Link to={"/newAppointments"} className="statistics-box">
        <StatisticsCard
          number={statistics?.new || 0}
          title={messages.statistics.appointments.new}
          icon={<AddIcon className="icon-wrapper_icon" />}
          classes="new"
        />
      </Link>
      {/* <Link to={"/activeAppointments"} className="statistics-box">
        <StatisticsCard
          number={statistics?.active || 0}
          title={messages.statistics.appointments.active}
          icon={<CachedIcon className="icon-wrapper_icon" />}
          classes="active"
        />
      </Link> */}
      <Link to={"/activeAppointments"} className="statistics-box">
        <StatisticsCard
          number={statistics?.active || 0}
          title={messages.statistics.appointments.not_completed}
          icon={<ErrorOutlineIcon className="icon-wrapper_icon" />}
          classes="rejected"
        />
      </Link>
      <Link to={"/completedAppointments"} className="statistics-box">
        <StatisticsCard
          number={statistics?.completed || 0}
          title={messages.statistics.appointments.completed}
          icon={<CheckIcon className="icon-wrapper_icon" />}
          classes="completed"
        />
      </Link>
      <Link to={"/canceledAppointments"} className="statistics-box">
        <StatisticsCard
          number={statistics?.canceled || 0}
          title={messages.statistics.appointments.canceled}
          icon={<BlockIcon className="icon-wrapper_icon" />}
          classes="canceled"
        />
      </Link>    
    </div>
  );
};

export default injectIntl(AppointmentsStatisticsWrapper);
